/**
 * DateFormat
 *
 */
const dateFormat = (date: string, formatType?: string) => {
  const d = new Date(date)
  let optionsDate: any = null
  switch (formatType) {
    case 'full-time':
      optionsDate = {
        day: 'numeric',
        month: 'numeric',
        year: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      }
      break
    case 'time':
      optionsDate = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      }
      return d.toLocaleTimeString('fr-FR', optionsDate)
    case 'full-date':
      optionsDate = {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
      }
      break
    case 'month-long':
      optionsDate = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }
      break
    case 'month-long-with-time':
      optionsDate = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }
      break
    default:
      optionsDate = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }
  }
  return d.toLocaleDateString('fr-FR', optionsDate)
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('date', {
    mounted(el, binding) {
      const { value, arg } = binding
      if (!value) {
        console.error('Please provide a date to format')
        el.innerHTML = ''
        return
      }
      el.innerHTML = dateFormat(value, arg)
    },
    updated(el, binding, vnode) {
      const { value, arg } = binding
      if (!value) {
        console.error('Please provide a date to format')
        el.innerHTML = ''
        return
      }
      el.innerHTML = dateFormat(value, arg)
    },
  })
})
